"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const TabPanel_1 = __importDefault(require("./TabPanel"));
require("./index.css");
const mobx_react_lite_1 = require("mobx-react-lite");
const SearchPage_1 = __importDefault(require("./states/SearchPage"));
const Root = (0, mobx_react_lite_1.observer)(({ userId, locale, bearer }) => {
    SearchPage_1.default.userId = userId;
    SearchPage_1.default.locale = locale;
    SearchPage_1.default.bearer = bearer;
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(TabPanel_1.default, {}) }));
});
const run = () => {
    const search = document.getElementById('search');
    if (!search)
        return;
    const root = (0, client_1.createRoot)(search);
    root.render((0, jsx_runtime_1.jsx)(Root, { bearer: search.getAttribute('data-bearer'), locale: search.getAttribute('data-locale'), userId: search.getAttribute('data-user-id') }));
};
run();
